export const PAGE_TITLE = "Silent Light Publishers";

export const PAGE_TEXT =
  "Anahat Education Group is pleased to work with students and graduates of the Institute of Interpersonal Hypnotherapy to get their books published through Silent Light Publishers (SLP).  SLP works with the following team members to help you to get your book published from start to finish.  From your initial ideas to seeing your book in print, we can help.  We offer the following solutions:";

export const VIDEO_URL =
  "https://drive.google.com/file/d/1oJjHm7T0H0_rIefLL7sS3ZpFr21_2-1d/preview";

export const AMAZON_BOOK_LINK =
  "https://www.amazon.com/Facilitating-Enlightenment-Interpersonal-Hypnotherapy-Self-Realization/dp/B0DW3SGQWF?crid=37ADKL9492XLV&dib=eyJ2IjoiMSJ9.D273LUo7RDDC7_uwFSJUiohOKe-2Xqi87lYAIcg3LladnA8cX_VvWG0GTZdl5jRzCgdX5fiFPwPTsQuHTdXXlA.E9oJrR_RFu9wpd5e0s3hGIBtXO9fhR6q1Ul4AE0R1_4&dib_tag=se&keywords=facilitating+enlightenment&qid=1741363564&sprefix=faciliating+en,aps,126&sr=8-1&linkCode=sl1&tag=silentlightpu-20&linkId=d6aa8146713a41c4cd7e229d60094367&language=en_US&ref_=as_li_ss_tl";

export const EMAIL_LINK =
  "mailto:support@mynirva.com?subject=Book%20Publishing%20Inquiry";

export const EMAIL_ADDRESS = "support@mynirva.com";

export const BOOK_TITLE = "Facilitating Enlightenment";

export const ANNOUNCEMENT_TEXT = "Announcing the new book";

export const EMAIL_CARD_TITLE = "Email link to";

export const EMAIL_CARD_SUBTITLE = "Click here to begin your journey.";

export const BOOK_IMAGE = require("../../../assets/images/publishers1.webp");
